import AdyenCheckout from '@adyen/adyen-web'
import { OnPaymentCompletedData } from '@adyen/adyen-web/dist/types/components/types'
import AdyenCheckoutError from '@adyen/adyen-web/dist/types/core/Errors/AdyenCheckoutError'
import { CoreOptions } from '@adyen/adyen-web/dist/types/core/types'
import { CustomTranslations } from '@adyen/adyen-web/dist/types/language/types'
import { captureException } from '@sentry/react'

const ADYEN_ENVIRONMENT = process.env.VITE_ADYEN_ENVIRONMENT

function createAdyenCheckout(
    session: { [key: string]: string },
    onCompleted: (code: OnPaymentCompletedData) => void,
    onError: (error: AdyenCheckoutError) => void,
    translations?: CustomTranslations
) {
    /******** WORKAROUND UNTIL WE DEFINE WHICH API_KEY WE ARE GONNA USE */
    let ADYEN_CLIENT_KEY
    const location = window.location.pathname
    if (/carpay/.test(location)) ADYEN_CLIENT_KEY = process.env.VITE_CARPAY_ADYEN_CLIENT_KEY
    else ADYEN_CLIENT_KEY = process.env.VITE_BOOKING_ADYEN_CLIENT_KEY
    /******* REMOVE THIS IN FUTURE */

    const configuration: CoreOptions = {
        environment: ADYEN_ENVIRONMENT,
        clientKey: ADYEN_CLIENT_KEY,
        session,
        onPaymentCompleted: (result) => {
            onCompleted(result)
        },
        onError: (error, element) => {
            if (error.name === 'CANCEL') return
            captureException(
                `There has been an error on Adyen Config: ${error.name}, ${error.message}, ${error.stack}, ${element}`
            )

            onError(error)
        },
        paymentMethodsConfiguration: {
            storedCard: {
                hideCVC: true
            },
            card: {
                hasHolderName: true,
                holderNameRequired: false
            }
        },
        ...(translations && { translations })
    }

    return AdyenCheckout(configuration)
}

export default createAdyenCheckout
